import { render, staticRenderFns } from "./LoadLayout.vue?vue&type=template&id=37a49eb4&scoped=true&"
import script from "./LoadLayout.vue?vue&type=script&lang=js&"
export * from "./LoadLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37a49eb4",
  null
  
)

export default component.exports